import { alpha, Box, Stack, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from 'react-router-dom';
import { useGetMyCreditsQuery } from '../../../store/api/creditsApi';

const WARN_THRESHOLD = 20;

export function LowBalanceBanner() {
  const { data } = useGetMyCreditsQuery();
  const navigate = useNavigate();
  if (!data || data.unlimited || !data.systemEnabled) return null;

  const handleRecargar = () => {
    window.dispatchEvent(new CustomEvent('gustavo:close'));
    navigate('/marketplace');
  };

  // El saldo del wallet, igual que el chip y que la vista de Créditos: es lo único que el
  // cobro respeta. Derivarlo del cupo dejaba invisible todo movimiento de un admin —el
  // banner le decía "Gustavo está pausado" a alguien con 290 créditos recién cargados, y
  // callaba con alguien a quien le habían debitado hasta 0. (16/08/2026)
  const remaining = data.balance;

  if (remaining > WARN_THRESHOLD) return null;

  const isZero   = remaining <= 0;
  const accent   = isZero ? '#F87171' : '#FBBF24';
  const Icon     = isZero ? ErrorOutlineIcon : WarningAmberIcon;
  const title    = isZero ? 'Sin créditos disponibles' : `Créditos bajos — quedan ${remaining.toLocaleString('es-UY', { maximumFractionDigits: 2 })}`;
  const body     = isZero
    ? 'Gustavo está pausado. Recargá para continuar operando.'
    : 'Estás por agotar tu saldo. Recargá antes de que se corte.';

  return (
    <Box sx={{
      mx: 1.5, mt: 1,
      px: 1.5, py: 1,
      borderRadius: 1.5,
      bgcolor: alpha(accent, 0.07),
      border: `1px solid ${alpha(accent, 0.25)}`,
    }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1.5}>
        <Stack direction="row" alignItems="flex-start" gap={1} sx={{ flex: 1, minWidth: 0 }}>
          <Icon sx={{ fontSize: 15, color: accent, mt: '2px', flexShrink: 0 }} />
          <Box>
            <Typography sx={{ fontSize: 12.5, fontWeight: 700, color: accent, lineHeight: 1.3 }}>
              {title}
            </Typography>
            <Typography sx={{ fontSize: 11.5, color: alpha(accent, 0.75), lineHeight: 1.4, mt: 0.25 }}>
              {body}
            </Typography>
          </Box>
        </Stack>
        <Box
          component="button"
          onClick={handleRecargar}
          sx={{
            flexShrink: 0,
            fontSize: 11.5,
            fontWeight: 700,
            color: '#0A0A0A',
            background: `linear-gradient(90deg, ${accent}, ${isZero ? '#FCA5A5' : '#FDE68A'})`,
            px: 1.5, py: 0.5,
            borderRadius: 1,
            border: 'none',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            '&:hover': { opacity: 0.88 },
          }}
        >
          Recargar →
        </Box>
      </Stack>
    </Box>
  );
}
